<template>
  <div v-if="hasOpenModals" class="modal-backdrop fade in show"></div>
</template>

<script>
/**
 * @param Wrapper
 *
 * @description Az oldalakon a felugró ablakok vezérlése
 */
import { mapGetters } from 'vuex'

export default {
  name: 'modal-wrapper',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['openModals']),
    hasOpenModals() {
      const condition = this.openModals.length > 0
      document.body.classList.toggle('modal-open', condition)
      return condition
    },
  },
}
</script>
